import { render, staticRenderFns } from "./ImportOrdersTemplateForm.vue?vue&type=template&id=568881ce"
import script from "./ImportOrdersTemplateForm.vue?vue&type=script&lang=js"
export * from "./ImportOrdersTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports